import type {
  TRemotePaymentMethod,
  TRemotePaymentMethodServer,
} from '../../store/types';

export const remotePaymentMethodsAdapter = (items: TRemotePaymentMethodServer[]): TRemotePaymentMethod[] => {
  const remotePaymentMethods: TRemotePaymentMethod[] = items.map((item) => ({
    id: item.id,
    created: item.created,
    currency: item.currency,
    paymentSystemId: item.payment_system_id,
    paymentSystemName: item.payment_system_name,
    name: item.name,
    data: JSON.stringify(item.data),
    minRefill: item.min_refill,
    maxRefill: item.max_refill,
  }));

  return remotePaymentMethods;
};
